var exports = {
  "S": "x4ddf2309--0d1240--banner-layout",
};

module.exports = exports;
